<template>
  <svg
    id="right_icon"
    data-name="right icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <rect
      id="Rectangle_1862"
      data-name="Rectangle 1862"
      width="24"
      height="24"
      transform="translate(0 0)"
      fill="none"
    />
    <path
      id="Path_2390"
      data-name="Path 2390"
      d="M5.119,15.01l-.188-13.3A1.66,1.66,0,0,1,6.541,0a1.66,1.66,0,0,1,1.61,1.706l.188,10.451V7.152a1.549,1.549,0,0,1,1.61-1.481,1.549,1.549,0,0,1,1.61,1.481V8.493a1.613,1.613,0,0,1,3.22,0V9.829a1.615,1.615,0,0,1,3.22,0v5.792c.083,6.833-4.652,6.373-4.652,6.373H8.887A6.224,6.224,0,0,1,4.4,19.627L.472,14.911a1.778,1.778,0,0,1,0-2.412,1.547,1.547,0,0,1,2.277,0l2.32,2.458"
      transform="translate(4.5 1)"
      fill="none"
      stroke="#2d323c"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <g
      id="Group_4928"
      data-name="Group 4928"
      transform="translate(0.757 0.757)"
    >
      <g id="Group_4934" data-name="Group 4934" transform="translate(-1)">
        <rect
          id="Rectangle_1861"
          data-name="Rectangle 1861"
          width="4"
          height="1"
          transform="translate(3.243 0.743)"
          fill="#2d323c"
        />
        <path
          id="Polygon_24"
          data-name="Polygon 24"
          d="M2,0,4,3H0Z"
          transform="translate(0.243 3.243) rotate(-90)"
          fill="#2d323c"
        />
      </g>
    </g>
    <g id="Group_4935" data-name="Group 4935" transform="translate(15)">
      <g id="Group_4934-2" data-name="Group 4934">
        <rect
          id="Rectangle_1861-2"
          data-name="Rectangle 1861"
          width="4"
          height="1"
          transform="translate(0 1.5)"
          fill="#2d323c"
        />
        <path
          id="Polygon_24-2"
          data-name="Polygon 24"
          d="M2,0,4,3H0Z"
          transform="translate(7) rotate(90)"
          fill="#2d323c"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SwipeNavigation',
}
</script>

<style lang="scss" scoped></style>
